import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { Box, Button, TextField, Typography, Modal } from "@mui/material";
import MUIDataTable from "mui-datatables";
import SearchIcon from "@mui/icons-material/Search";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconUI from "../../components/ui/icon_ui";
import { services } from "../../services/api";
import { NotificacionContext } from "../../context/notificacion_context";
import GifLoader from "../../components/ui/gifLoader";
import { styled } from "@mui/material/styles";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DownloadIcon from "@mui/icons-material/Download";

export const Reporte = () => {
  const { showNotification } = useContext(NotificacionContext);
  const [filtros, setFiltros] = useState({
    fechaI: dayjs().format("YYYY-MM-DD"),
    fechaF: dayjs().format("YYYY-MM-DD"),
    lineaCaptura: "",
  });
  const [loadingPdf, setLoadingPdf] = useState(true);
  const [loader, setloader] = useState(false);
  const [state, setState] = useState({
    referenciasGlobales: [],
    detallesRerefencias: [],
  });
  const [modalShow, setModalShow] = useState({
    viewPdf: false,
    detallesGlobal: false,
    selectedReferencia: null,
    confirmUpload: false,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilaId, setSelectedFilaId] = useState(null);

  const colorUI = "#6f1d46";
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: colorUI,
    "&:hover": {
      backgroundColor: colorUI,
    },
  }));

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "80%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const styleModalPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const options = {
    selectableRows: false,
    tableBodyHeight: "auto",
    setRowProps: (row, dataIndex) => {
      const fila = state?.referenciasGlobales?.data?.[dataIndex];
      if (fila?.status === "Pagado" && fila?.comprobante_url === null) {
        return {
          style: { backgroundColor: "#eb5353" },
        };
      }
      if (fila?.status === "Pendiente de pago") {
        return {
          style: { backgroundColor: "#ecec86" },
        };
      }
      return {};
    },
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtrar tabla",
      },
      filter: {
        all: "Todo",
        title: "Filtros",
        reset: "Restaurar",
      },
      viewColumns: {
        title: "Ver columnas",
        titleAria: "Mostrar/Ocultar columnas en la tabla",
      },
      selectedRows: {
        text: "columna(s) selecciona(as)",
        delete: "Eliminar",
        deleteAria: "Eliminar filas seleccionadas",
      },
    },
    responsive: "scroll",
    downloadOptions: {
      filename: "tablaSolicitudes.csv",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: false,
      },
    },
  };

  const columns = [
    {
      name: "lineaCaptura",
      label: "Línea de captura",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "cantidadReferencias",
      label: "Cantidad de referencias",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "monto",
      label: "Importe",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>${value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "fechaCreacion",
      label: "Fecha de generación",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Estatus",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "Comprobante",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const fila = state?.referenciasGlobales?.data?.[dataIndex];

          if (fila?.status === "Pendiente de pago") {
            return null;
          }

          return (
            <>
              <div className="w-100 d-flex justify-content-center align-items-center ">
                {fila.ruta_comprobante !== null ? (
                  <div
                    onClick={() => window.open(fila.comprobante_url, "_blank", 'noopener')}
                    style={{
                      height: 30,
                      width: 30,
                      zIndex: 0,
                      cursor: "pointer",
                    }}
                    className="cta cta--primary cta--icon icon_btn me-1"
                  >
                    <IconUI size={"30px"} color={"white"}>
                      <DownloadIcon />
                    </IconUI>
                    <div className="icon_btn_help">Descargar archivo</div>
                  </div>
                ) : (
                  <label htmlFor={`file-upload-${dataIndex}`}>
                    <input
                      id={`file-upload-${dataIndex}`}
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e, fila.id)}
                    />
                    <div
                      style={{
                        height: 30,
                        width: 30,
                        zIndex: 0,
                        cursor: "pointer",
                      }}
                      className="cta cta--primary cta--icon icon_btn me-1"
                    >
                      <IconUI size={"30px"} color={"white"}>
                        <FileUploadIcon />
                      </IconUI>
                      <div className="icon_btn_help">Subir archivo</div>
                    </div>
                  </label>
                )}
              </div>
            </>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const fila = state?.referenciasGlobales?.data?.[dataIndex];

          return (
            <>
              <div className="w-100 d-flex justify-content-center align-items-center ">
                <div
                  onClick={() => detallesGlobal(fila.id)}
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn me-1"
                >
                  <IconUI size={"30px"} color={"white"}>
                    <InfoOutlinedIcon />
                  </IconUI>
                  <div className="icon_btn_help">Ver detalles</div>
                </div>
                <div
                  onClick={() => {
                    setModalShow({
                      ...modalShow,
                      viewPdf: true,
                      selectedReferencia: dataIndex,
                    });
                  }}
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn me-1"
                >
                  <IconUI size={"30px"} color={"white"}>
                    <InsertDriveFileIcon />
                  </IconUI>
                  <div className="icon_btn_help">Ver PDF</div>
                </div>
              </div>
            </>
          );
        },
      },
    },
  ];

  const columnsDetalles = [
    {
      name: "lcaptura",
      label: "Referencia",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "created_at",
      label: "Fecha generación",
      options: {
        customBodyRender: (value) => {
          const formattedDate =
            value !== null ? new Date(value).toISOString().slice(0, 10) : "N/A";

          return (
            <div className="w-100 d-flex justify-content-center align-items-center">
              <p>{formattedDate}</p>
            </div>
          );
        },
      },
    },
    {
      name: "fechaPago",
      label: "Fecha de cobro",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value !== null ? value : "N/A"}</p>
            </div>
          );
        },
      },
    },
    {
      name: "importe",
      label: "Importe pagado",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>${value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "nombreAcreditador",
      label: "Nombre",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
  ];

  const handleFiltros = ({ target: { name, value } }) => {
    setFiltros({ ...filtros, [name]: value });
  };

  const getLineasGlobales = async (type) => {
    setloader(true);

    const bodySend = {
      fechaInicio: filtros.fechaI,
      fechaFin: filtros.fechaF,
    };

    if (type === "buscar" && filtros.lineaCaptura.trim() !== "") {
      bodySend.lineaCaptura = filtros.lineaCaptura;
    }

    const response = await services(
      "POST",
      "lineas-captura-globales",
      bodySend,
    );

    if (response.status === 200) {
      setState({ ...state, referenciasGlobales: response.data });
    } else {
      showNotification(
        "error",
        "Acción No Exitosa!",
        "Error al obtener las referencias globales",
        null,
        4,
      );
    }
    setloader(false);
  };

  const handleFileChange = (event, filaId) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setSelectedFilaId(filaId);
      setModalShow({ ...modalShow, confirmUpload: true });
    }
    event.target.value = null;
  };

  const confirmUploadFile = () => {
    sendFileCajaChica(selectedFile, selectedFilaId);
    setModalShow({ ...modalShow, confirmUpload: false });
  };

  const sendFileCajaChica = async (file, filaId) => {
    setloader(true);

    const formData = new FormData();
    formData.append("id", filaId);
    formData.append("comprobanteCc", file);

    const response = await services(
      "POST",
      "subirComprobanteCajaChica",
      formData,
    );

    if (response.status === 200) {
      showNotification(
        "success",
        "Acción Exitosa!",
        "Archivo subido correctamente",
        null,
        4,
      );
      getLineasGlobales();
    } else {
      showNotification(
        "error",
        "Error al subir el archivo",
        response.data?.message || "Error al subir el archivo",
        null,
        4,
      );
    }
    setloader(false);
  };

  const detallesGlobal = async (id) => {
    setloader(true);

    const bodySend = {
      fechaInicio: filtros.fechaI,
      fechaFin: filtros.fechaF,
    };

    const response = await services(
      "GET",
      `lineas-captura-global/${id}/diversos`,
      bodySend,
    );

    if (response.status === 200) {
      setState({ ...state, detallesRerefencias: response.data });
      setModalShow({ ...modalShow, detallesGlobal: true });
    } else {
      setModalShow({ ...modalShow, detallesGlobal: false });
      showNotification(
        "error",
        "Acción No Exitosa!",
        "Error al obtener los detalles",
        null,
        4,
      );
    }

    setloader(false);
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getLineasGlobales();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {loader ? <GifLoader /> : null}
      <div className="container my-3">
        <div className="border-bottom--guinda text-big mb-2 text-bold">
          <h2>Reporte de referencias globales</h2>
        </div>

        <div
          style={{ columnGap: 15, rowGap: 20 }}
          className="d-flex flex-wrap flex-row justify-content-center m-2 my-5"
        >
          <TextField
            InputLabelProps={{ shrink: true }}
            onChange={handleFiltros}
            value={filtros.fechaI}
            name="fechaI"
            label="Fecha Inicio"
            size="small"
            type="date"
          />
          <TextField
            InputLabelProps={{ shrink: true }}
            onChange={handleFiltros}
            value={filtros.fechaF}
            name="fechaF"
            label="Fecha Fin"
            size="small"
            type="date"
          />
          <TextField
            name="lineaCaptura"
            label="Buscar por línea de captura"
            variant="outlined"
            value={filtros.lineaCaptura}
            onChange={handleFiltros}
            InputProps={{
              sx: {
                height: "40px",
                "& input": {
                  padding: "10px 14px",
                },
              },
            }}
            InputLabelProps={{ shrink: true }}
          />
          <Button
            startIcon={<SearchIcon />}
            onClick={() => getLineasGlobales("buscar")}
            variant="contained"
            sx={{
              backgroundColor: "#6f1d46",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#6f1d46",
                boxShadow: "inset 0 0 0 1000px rgba(255,255,255,0.1)",
              },
            }}
          >
            Consultar
          </Button>
        </div>

        <MUIDataTable
          style={{ overflow: "hidden" }}
          data={state?.referenciasGlobales?.data}
          columns={columns}
          options={options}
        />
      </div>

      <Modal
        open={modalShow.detallesGlobal}
        onClose={() => {
          setModalShow({ ...modalShow, detallesGlobal: false });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <h2 className="mb-4 text-center">Detalles de línea de captura</h2>

          <div className="d-flex flex-column gap-4 mb-2">
            <MUIDataTable
              style={{ overflow: "hidden" }}
              data={state?.detallesRerefencias?.data}
              columns={columnsDetalles}
              options={options}
            />
          </div>

          <div className="d-flex flex-md-row gap-3 mt-4 gap-md-0 justify-content-end">
            <ColorButton
              className="bg-danger"
              variant="outlined"
              onClick={() => {
                setModalShow({ ...modalShow, detallesGlobal: false });
              }}
            >
              Cerrar
            </ColorButton>
          </div>
        </Box>
      </Modal>

      {modalShow.viewPdf ? (
        <Modal
          open={modalShow.viewPdf}
          onClose={() => {
            setModalShow({ ...modalShow, viewPdf: false });
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModalPdf}>
            <h2 className="mb-4 text-center">Detalles de PDF</h2>

            {loadingPdf && (
              <div className="d-flex justify-content-center align-items-center py-3">
                <p>Cargando PDF...</p>
              </div>
            )}

            <object
              data={
                state?.referenciasGlobales?.data[modalShow.selectedReferencia]
                  ?.pdf
              }
              type="application/pdf"
              height="70%"
              width="100%"
              aria-label="formato"
              onLoad={() => setLoadingPdf(false)}
            ></object>

            <div className="position-absolute end-0 bottom-0 m-3">
              <ColorButton
                className="bg-danger "
                variant="outlined"
                onClick={() => {
                  setModalShow({ ...modalShow, viewPdf: false });
                  setLoadingPdf(true);
                }}
              >
                Cerrar
              </ColorButton>
            </div>
          </Box>
        </Modal>
      ) : null}

      <Modal
        open={modalShow.confirmUpload}
        onClose={() => {
          setModalShow({ ...modalShow, confirmUpload: false });
          setSelectedFile(null);
          setSelectedFilaId(null);
        }}
      >
        <Box sx={styleModal}>
          <h2 className="mb-4 text-center">Confirmar subida de archivo</h2>
          <p className="text-center mb-4">
            ¿Estás seguro de que deseas subir el archivo{" "}
            <strong>{selectedFile?.name}</strong>?
          </p>
          <div className="d-flex justify-content-center gap-3">
            <ColorButton
              variant="outlined"
              onClick={() => {
                setModalShow({ ...modalShow, confirmUpload: false });
                setSelectedFile(null);
                setSelectedFilaId(null);
              }}
            >
              Cancelar
            </ColorButton>
            <ColorButton variant="contained" onClick={confirmUploadFile}>
              Confirmar
            </ColorButton>
          </div>
        </Box>
      </Modal>
    </>
  );
};
